// Marks the input a multi select filter cell was created on, so the widget can be found again per column.
const MULTI_SELECT_FILTER_CLASS = "multiSelectFilterCell";

// A Kendo filter descriptor: either a single condition (field/operator/value) or a group of them (logic/filters).
type FilterDescriptorLike = {
    field?: string,
    operator?: string,
    value?: unknown,
    logic?: string,
    filters?: Array<FilterDescriptorLike>
};

export function createDateFilterTemplate() {
    return (container) => createEasyDateFilterTemplate(container);
}

export function createDateTimeFilterTemplate() {
    return (container) => createEasyDateFilterTemplate(container);
}

export function createEasyDateFilterTemplate(container) {
    const options = [
        { text: TextResources.Views_Alle, value: "all" },
        { text: TextResources.Views_Heute, value: "today" },
        { text: TextResources.Views_ThisMonth, value: "thisMonth" },
        { text: TextResources.Views_LastMonth, value: "lastMonth" },
        { text: TextResources.Views_ThisYear, value: "thisYear" },
        { text: TextResources.Views_LastYear, value: "lastYear" },
        { text: TextResources.Views_Custom, value: "custom", disabled: true }
    ];

    const grid = container.element.closest("[data-role='grid']").data("kendoGrid");
    const filterCell = container.element.parents(".k-filtercell");
    const dataField = filterCell.data("field");
    filterCell.empty();
    filterCell.html(`<input id='customFilter_${dataField}'/>`)
    $(`#customFilter_${dataField}`, filterCell).kendoDropDownList({
        dataTextField: "text",
        dataValueField: "value",
        dataSource: options,
        autoWidth: true,
        change: (e) => {
            const selected = e.sender.value();
            const newFilter = getDateFilter(selected, dataField);
            const currentFilter = grid.dataSource.filter();
            const otherFilters = (currentFilter?.filters || []).filter((f) => f.field !== dataField);

            const combinedFilter = {
                logic: "and",
                filters: [...otherFilters, ...newFilter.filters]
            };
            grid.dataSource.filter(combinedFilter);
        },
        select: (e) => {
            if (e.dataItem.disabled) {
                e.preventDefault();
            }
        }
    });

    grid.bind("filter", (e) => {
        updateDateTimeFilterDropdownValue(e, dataField);
    });
    setTimeout(() => {
        grid.one("dataBound", (e) => {
            updateDateTimeFilterDropdownValue(e, dataField)
        });
    }, 0);
}

export function updateDateTimeFilterDropdownValue(e, dataField) {
    const grid = e.sender;
    const ddlInput = $(e.sender.element).find(`.k-filtercell[data-field="${dataField}"] .k-dropdownlist input[data-role="dropdownlist"]`)
    const ddl = ddlInput.data("kendoDropDownList");
    if (ddl) {
        const filterList = e.filter?.filters || grid.dataSource.filter()?.filters || [];
        const dateFilter = filterList.filter((f) => f.field === dataField);
        const selectedKey = getKeyFromDateFilter(dateFilter);
        if (selectedKey) {
            ddl.value(selectedKey);
        }
    }
}

export function getDateFilter(key, field) {
    const today = new Date();
    let from;
    let to;

    switch (key) {
        case "today":
            from = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
            to = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
            break;
        case "thisMonth":
            from = new Date(today.getFullYear(), today.getMonth(), 0);
            to = new Date(today.getFullYear(), today.getMonth() + 1, 1);
            break;
        case "lastMonth":
            from = new Date(today.getFullYear(), today.getMonth() - 1, 0);
            to = new Date(today.getFullYear(), today.getMonth(), 1);
            break;
        case "thisYear":
            from = new Date(today.getFullYear(), 0, 0);
            to = new Date(today.getFullYear() + 1, 0, 1);
            break;
        case "lastYear":
            from = new Date(today.getFullYear() - 1, 0, 1);
            to = new Date(today.getFullYear(), 0, 1);
            break;
        default:
            return { logic: "and", filters: [] };
    }

    return {
        logic: "and",
        filters: [
            { field, operator: "gt", value: from },
            { field, operator: "lt", value: to }
        ]
    };
}

export function getKeyFromDateFilter(filter) {
    if (!filter || !Array.isArray(filter) || filter.length === 0) {
        return "all";
    }

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    let from = null;
    let to = null;

    for (let i = 0; i < filter.length; i++) {
        const f = filter[i];
        if (f.operator === "gt") {
            from = new Date(f.value);
        }
        if (f.operator === "lt") {
            to = new Date(f.value);
        }
    }

    const isSameDate = (a, b) => a?.getTime() === b?.getTime();

    const todayRangeStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    const todayRangeEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    if (isSameDate(from, todayRangeStart) && isSameDate(to, todayRangeEnd)) return "today";

    const monthStart = new Date(today.getFullYear(), today.getMonth(), 0);
    const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    if (isSameDate(from, monthStart) && isSameDate(to, monthEnd)) return "thisMonth";

    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 0);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 1);
    if (isSameDate(from, lastMonthStart) && isSameDate(to, lastMonthEnd)) return "lastMonth";

    const yearStart = new Date(today.getFullYear(), 0, 0);
    const yearEnd = new Date(today.getFullYear() + 1, 0, 1);
    if (isSameDate(from, yearStart) && isSameDate(to, yearEnd)) return "thisYear";

    const lastYearStart = new Date(today.getFullYear() - 1, 0, 1);
    const lastYearEnd = new Date(today.getFullYear(), 0, 1);
    if (isSameDate(from, lastYearStart) && isSameDate(to, lastYearEnd)) return "lastYear";

    return "custom";
}

export function createBoolFilterTemplate(trueString: string = null, falseString: string = null) {
    let resultingTrueString;
    let resultingFalseString;

    if (!trueString) {
        resultingTrueString = TextResources.Views_Ja;
    } else {
        resultingTrueString = trueString;
    }

    if (!falseString) {
        resultingFalseString = TextResources.Views_Nein;
    } else {
        resultingFalseString = falseString;
    }

    return (container) => container.element.kendoDropDownList(
        {
            valuePrimitive: true,
            autoWidth: true,
            dataSource:
            {
                data: [
                    { text: resultingTrueString, value: true },
                    { text: resultingFalseString, value: false }
                ]
            },
            dataTextField: "text",
            dataValueField: "value",
            optionLabel: TextResources.Views_Alle
        }
    );
}

export function createNumericFilterTemplate(min: number = null, max: number = null) {
    return (container) => container.element.kendoNumericTextBox({ min, max });
}

export function createLiveUpdateNumericFilterTemplate(decimals: number, min: number = null, max: number = null) {
    return (container) => {
        container.element.keyup((e) => {
            setTimeout(() => {
                let liveFilter = true;
                if (min && max) {
                    const val = $(e.target).val();
                    if (!Number.isNaN(parseFloat(val as string))) {
                        if (val < min || val > max) {
                            liveFilter = false;
                        }
                    }
                }

                if (e.key !== "." && liveFilter) {
                    $(e.target).data().kendoNumericTextBox.value($(e.target).val()); // Apply value to textbox before triggering change
                    $(e.target).data().kendoNumericTextBox.trigger("change");
                }
            }, 200);
        });
        container.element.kendoNumericTextBox({
            min,
            max,
            decimals,
            round: false,
            format: `n${decimals}`,
            spin: (e) => {
                setTimeout(() => {
                    e.sender.element.data().kendoNumericTextBox.trigger("change");
                }, 200);
            }
        });
    };
}

export function createLiveUpdateTextFilterTemplate() {
    return (container) => {
        container.element.parent().addClass("k-widget k-autocomplete k-header k-state-default");
        container.element.addClass("k-input");
        container.element.keyup((e) => {
            setTimeout(() => {
                $(e.target).trigger("change");
            }, 200);
        });
    };
}

export function createAutoCompleteTextFilterTemplate(textField: string, filter: string) {
    return (container) => container.element.kendoAutoComplete(
        {
            autoWidth: true,
            clearButton: false,
            dataSource: container.dataSource,
            dataTextField: textField,
            filter,
            valuePrimitive: true
        }
    );
}

export function createStaticDropDownFilterTemplate(dataSerialized: string) {
    return (container) => container.element.kendoDropDownList(
        {
            autoWidth: true,
            filter: "contains",
            dataSource: { data: dataSerialized },
            optionLabel: TextResources.Views_Alle
        }
    );
}

export function createStaticMultiSelectFilterTemplate(data: Array<{ Text: string, Value: string }>, filterOperator: string = "equals") {
    return (container) => createMultiSelectFilter(container, filterOperator,
        {
            dataSource: { data },
            dataTextField: "Text",
            dataValueField: "Value"
        }
    );
}

export function createDynamicMultiSelectFilterTemplate(action: string, filterOperator: string = "equals") {
    return (container) => createMultiSelectFilter(container, filterOperator,
        {
            autoBind: false,
            dataSource: { transport: { read: action } }
        }
    );
}

// A filter cell only ever applies one value per column, so the multi select applies the filter itself:
// one descriptor per selected value, OR-combined, replacing the previous filter of this column while
// keeping the filters of all other columns. Same approach as the date filter above, therefore the cell
// content is replaced as well so that the grid's own single-value cell binding is gone.
export function createMultiSelectFilter(container, filterOperator: string, options: kendo.ui.MultiSelectOptions) {
    const grid = container.element.closest("[data-role='grid']").data("kendoGrid");
    const filterCell = container.element.parents(".k-filtercell");
    const dataField = filterCell.data("field");
    const element = $(`<input class="${MULTI_SELECT_FILTER_CLASS}"/>`);
    filterCell.empty().append(element);

    const multiSelect = element.kendoMultiSelect(
        {
            ...options,
            valuePrimitive: true,
            autoClose: false,
            autoWidth: true,
            clearButton: true,
            downArrow: true,
            filter: "contains",
            tagMode: "single",
            placeholder: TextResources.Views_Alle,
            tagTemplate: createMultiSelectFilterTag(options.dataTextField),
            change: (e) => {
                updateMultiSelectFilterTitle(filterCell, e.sender);
                applyMultiSelectFilter(grid, dataField, filterOperator, e.sender.value());
            }
        }
    ).data("kendoMultiSelect");

    // Restore an already applied filter (saved view, remembered layout, filter of another grid tab).
    // Always set the value, even an empty one: the widget adopts the empty input's val() as the
    // phantom value [""], which a lazily loaded source (autoBind: false) never resolves away.
    multiSelect.value(getColumnFilterValues(grid.dataSource.filter(), dataField));
    updateMultiSelectFilterTitle(filterCell, multiSelect);
    grid.bind("dataBound", (e) => updateMultiSelectFilterValue(e, dataField));
}

// The filter cell is narrow, so a collapsed selection is labelled as short as possible: the value itself
// while it is the only one, its count as soon as there are several. The values are listed in the tooltip.
function createMultiSelectFilterTag(dataTextField: string) {
    return (data) => {
        const values: Array<string> = data?.values || [];
        if (values.length !== 1) {
            // Kendo puts the returned string into the tag unencoded, hence no user data without encoding.
            return String(values.length);
        }
        return kendo.htmlEncode(getItemText(data.dataItems?.[0], dataTextField) || values[0]);
    };
}

// Kendo titles every filter row cell "filter cell" (grid message filterCellTitle), which says nothing about
// the applied filter - the selected values are of actual use there.
function updateMultiSelectFilterTitle(filterCell, multiSelect) {
    filterCell.attr("title", getSelectedTexts(multiSelect).join(", "));
}

function getSelectedTexts(multiSelect): Array<string> {
    const values: Array<string> = multiSelect.value() || [];
    const dataItems: Array<unknown> = multiSelect.dataItems() || [];
    if (dataItems.length !== values.length) {
        // A lazily loaded source has no data items yet while a saved filter is being restored - there the
        // raw value is the label anyway (link labels and tags are filtered by their text).
        return values;
    }
    return dataItems.map((item, index) => getItemText(item, multiSelect.options.dataTextField) || values[index]);
}

function getItemText(item, dataTextField: string): string {
    if (item === null || item === undefined) {
        return "";
    }
    return dataTextField ? item[dataTextField] : String(item);
}

export function applyMultiSelectFilter(grid, dataField: string, filterOperator: string, values: Array<string>) {
    const currentFilter: FilterDescriptorLike = grid.dataSource.filter();
    const otherFilters = getFilterDescriptors(currentFilter).filter((f) => !getFilterFields(f).includes(dataField));
    // The filters of the other columns keep their own logic - only "and" can be flattened into the new expression.
    const keptFilters = otherFilters.length > 1 && currentFilter?.logic && currentFilter.logic !== "and"
        ? [{ logic: currentFilter.logic, filters: otherFilters }]
        : otherFilters;
    const filters = values.length > 0
        ? [...keptFilters, { logic: "or", filters: values.map((value) => ({ field: dataField, operator: filterOperator, value })) }]
        : keptFilters;

    grid.dataSource.filter(filters.length > 0 ? { logic: "and", filters } : {});
}

export function updateMultiSelectFilterValue(e, dataField: string) {
    const grid = e.sender;
    const filterCell = $(grid.element).find(`.k-filtercell[data-field="${dataField}"]`);
    const multiSelect = filterCell.find(`.${MULTI_SELECT_FILTER_CLASS}`).data("kendoMultiSelect");
    if (multiSelect) {
        const values = getColumnFilterValues(grid.dataSource.filter(), dataField);
        const currentValues: Array<string> = multiSelect.value() || [];
        if (values.length !== currentValues.length || values.some((value, index) => value !== currentValues[index])) {
            multiSelect.value(values);
        }
        updateMultiSelectFilterTitle(filterCell, multiSelect);
    }
}

export function getColumnFilterValues(filter: FilterDescriptorLike | Array<FilterDescriptorLike>, dataField: string): Array<string> {
    return getLeafDescriptors(filter)
        .filter((leaf) => leaf.field === dataField && leaf.value !== null && leaf.value !== undefined)
        .map((leaf) => String(leaf.value))
        // The multi select only ever offers real values, so an empty string in the filter is the phantom
        // initial value of an earlier session (saved view). Dropping it here heals the displayed selection
        // on restore; the persisted filter itself is rebuilt without it on the next change.
        .filter((value) => value !== "");
}

// The data source hands out either a group, a single descriptor or - untouched by kendo - a plain array.
function getFilterDescriptors(filter: FilterDescriptorLike | Array<FilterDescriptorLike>): Array<FilterDescriptorLike> {
    if (!filter) {
        return [];
    }
    if (Array.isArray(filter)) {
        return filter;
    }
    return filter.filters ? filter.filters : [filter];
}

function getLeafDescriptors(filter: FilterDescriptorLike | Array<FilterDescriptorLike>): Array<FilterDescriptorLike> {
    return getFilterDescriptors(filter).flatMap((descriptor) => descriptor.filters ? getLeafDescriptors(descriptor.filters) : [descriptor]);
}

function getFilterFields(filter: FilterDescriptorLike | Array<FilterDescriptorLike>): Array<string> {
    return getLeafDescriptors(filter).map((leaf) => leaf.field).filter((field): field is string => !!field);
}

export function createDynamicDropDownFilterTemplate(action: string) {
    return (container) => container.element.kendoDropDownList(
        {
            autoWidth: true,
            autoBind: false,
            filter: "contains",
            dataSource: { transport: { read: action } },
            optionLabel: TextResources.Views_Alle
        }
    );
}
